import { render, staticRenderFns } from "./FamiliaExistente.vue?vue&type=template&id=35b08661"
import script from "./FamiliaExistente.vue?vue&type=script&lang=js"
export * from "./FamiliaExistente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports